import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Typography
} from '@mui/material'
import { RoundedButton } from 'common/Button/Button'
import { ColorBoxContent } from 'common/ui/colorBox'

function ReviewPayment({
  goPreviousPage,
  handleCreate,
  hasCreated
}: {
  goPreviousPage: () => void
  handleCreate: () => void
  hasCreated: boolean
}) {
  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleConfirmOrder = () => {
    handleCreate()
    handleClickOpen()
  }
  const navigate = useNavigate()
  return (
    <div data-cy='reviewPayment'>
      <Box>
        <Typography variant='h5' sx={{ color: 'primary.dark' }}>
          Please Key In Your Details
        </Typography>
        <Box sx={{ display: 'flex' }}>
          <Typography sx={{ width: '60%' }}>
            Upon confirmation, an email will be sent to the provided email
            address which will contain a URL to check the status of your order
          </Typography>
          <RoundedButton
            variant='secondary'
            onClick={() => {
              goPreviousPage()
            }}
          >
            Edit Details
          </RoundedButton>
        </Box>
        <Box
          sx={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}
        >
          <Checkbox />
          <Typography>
            I agree to the <Link>terms and conditions.</Link>
          </Typography>
        </Box>
        <ColorBoxContent>
          <Typography variant='h4' sx={{ color: 'primary.dark' }}>
            Proceed to Purchase
          </Typography>
          <Typography>
            Click the button below to confirm your purchase order
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '24px'
            }}
          >
            <RoundedButton
              variant='filled'
              onClick={() => handleConfirmOrder()}
            >
              Confirm Order
            </RoundedButton>
          </Box>
        </ColorBoxContent>
        {hasCreated && (
          <Dialog open={open} aria-labelledby='draggable-dialog-title'>
            <DialogTitle style={{ cursor: 'move' }} id='draggable-dialog-title'>
              Confirm Order
            </DialogTitle>
            <DialogContent onClick={() => navigate('/app/orders')}>
              <DialogContentText>
                Order Confirmed. We will proceed with processing your order
                shortly. Thank you!
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                onClick={() => navigate('/app/orders')}
                variant='noBackground'
              >
                Cancel
              </Button>
              <Button
                onClick={() => navigate('/app/orders')}
                variant='noBackground'
              >
                View your orders
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Box>
    </div>
  )
}

export default ReviewPayment
